/**
 * API client de anexos de orcamento (Bloco F item 4).
 *
 *   GET    /api/orcamento-anexos?orcamento=<uuid>
 *   POST   /api/orcamento-anexos          multipart: orcamento, arquivo, descricao
 *   PATCH  /api/orcamento-anexos/{id}     so descricao
 *   DELETE /api/orcamento-anexos/{id}
 */

const PREFIXO = "/api/orcamento-anexos";

export function listarAnexos(request, orcamentoId) {
  return request(`${PREFIXO}?orcamento=${orcamentoId}`);
}

export function uploadAnexo(request, { orcamentoId, arquivo, descricao = "" }) {
  const formData = new FormData();
  formData.append("orcamento", orcamentoId);
  formData.append("arquivo", arquivo);
  if (descricao) formData.append("descricao", descricao);
  return request(PREFIXO, {
    method: "POST",
    body: formData,
  });
}

export function deletarAnexo(request, id) {
  return request(`${PREFIXO}/${id}`, { method: "DELETE" });
}

export function atualizarDescricaoAnexo(request, id, descricao) {
  return request(`${PREFIXO}/${id}`, {
    method: "PATCH",
    body: JSON.stringify({ descricao }),
  });
}
